import { TRANSLATIONS_EN_SHELL_AND_COMMON } from "./translations.en.shell-and-common";
import { TRANSLATIONS_EN_SETTINGS_CORE } from "./translations.en.settings-core";
import { TRANSLATIONS_EN_SETTINGS_GOOGLE } from "./translations.en.settings-google";
import { TRANSLATIONS_EN_SETTINGS_MICROSOFT } from "./translations.en.settings-microsoft";
import { TRANSLATIONS_EN_DOCUMENTS_AND_DRIVE } from "./translations.en.documents-and-drive";
import { TRANSLATIONS_EN_CHAT_TASKS_AND_PROFILE } from "./translations.en.chat-tasks-and-profile";
import { TRANSLATIONS_EN_DASHBOARD_AND_KNOWLEDGE } from "./translations.en.dashboard-and-knowledge";
import { TRANSLATIONS_EN_PLANS_AND_ADMIN } from "./translations.en.plans-and-admin";
import { TRANSLATIONS_EN_ONBOARDING } from "./translations.en.onboarding";
import { TRANSLATIONS_EN_GENERATION } from "./translations.en.generation";
import { TRANSLATIONS_EN_HOME_ACTIONS_AND_OVERVIEW } from "./translations.en.home-actions-and-overview";
import { TRANSLATIONS_EN_HOME_DECISION_DETAIL } from "./translations.en.home-decision-detail";
import { TRANSLATIONS_EN_HOME_QUEUE_AND_ACTIVITY } from "./translations.en.home-queue-and-activity";
import { TRANSLATIONS_EN_HOME_PULSE_AND_CALENDAR } from "./translations.en.home-pulse-and-calendar";
import { TRANSLATIONS_EN_HOME_QUALITY_AND_ALERTS } from "./translations.en.home-quality-and-alerts";

export const TRANSLATIONS_EN = {
  ...TRANSLATIONS_EN_SHELL_AND_COMMON,
  ...TRANSLATIONS_EN_SETTINGS_CORE,
  ...TRANSLATIONS_EN_SETTINGS_GOOGLE,
  ...TRANSLATIONS_EN_SETTINGS_MICROSOFT,
  ...TRANSLATIONS_EN_DOCUMENTS_AND_DRIVE,
  ...TRANSLATIONS_EN_CHAT_TASKS_AND_PROFILE,
  ...TRANSLATIONS_EN_DASHBOARD_AND_KNOWLEDGE,
  ...TRANSLATIONS_EN_PLANS_AND_ADMIN,
  ...TRANSLATIONS_EN_ONBOARDING,
  ...TRANSLATIONS_EN_GENERATION,
  ...TRANSLATIONS_EN_HOME_ACTIONS_AND_OVERVIEW,
  ...TRANSLATIONS_EN_HOME_DECISION_DETAIL,
  ...TRANSLATIONS_EN_HOME_QUEUE_AND_ACTIVITY,
  ...TRANSLATIONS_EN_HOME_PULSE_AND_CALENDAR,
  ...TRANSLATIONS_EN_HOME_QUALITY_AND_ALERTS,
};
